import { render } from "./trading-signals.vue?vue&type=template&id=4e5ec37b"
import script from "./trading-signals.vue?vue&type=script&lang=js"
export * from "./trading-signals.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__